import { QueryCombinerType } from 'module/api/filter/types';
import {
  MultiSelectField,
  MultiUserField,
} from 'module/types/filter-field/field/filterable-field';
import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { GroupedFilter } from 'module/types/filter-field/grouped-filter/filter';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { AccountPeopleProfile } from 'api/account-people/profile-type';
import { useSignalFieldsAsFilterableField } from 'helpers/fields/signal-fields/fields';
import { keyBy } from 'lodash';
import { useMemo } from 'react';

interface Props {
  userProfile: AccountPeopleProfile;
  signalConfigurationIds: number[];
}
export const useFilterForSignalsFetch = ({
  userProfile,
  signalConfigurationIds,
}: Props) => {
  const { fields, loading } = useSignalFieldsAsFilterableField();
  const fieldLookup = useMemo(() => {
    return keyBy(fields, 'fieldName');
  }, [fields]);
  const reportedByField = useMemo(() => {
    return fieldLookup['reportedBy'];
  }, [fieldLookup]);
  const signalConfigurationField = useMemo(() => {
    return fieldLookup['signalConfigurationId'];
  }, [fieldLookup]);

  const filter: GroupedFilter = useMemo(
    () => ({
      type: QueryCombinerType.All,
      defaultGroup: FilterGroupType.Signal,
      groupCriteria: [
        {
          id: FilterGroupType.Signal,
          criteria: {
            field: signalConfigurationField as MultiSelectField,
            type: SelectFilterOperationType.IsOneOf,
            value: signalConfigurationIds,
          },
        },
        {
          id: FilterGroupType.Signal,
          criteria: {
            field: reportedByField as MultiUserField,
            type: SelectFilterOperationType.Is,
            value: [userProfile.user.userId],
          },
        },
      ],
    }),
    [
      signalConfigurationIds,
      reportedByField,
      signalConfigurationField,
      userProfile.user.userId,
    ],
  );

  return {
    filter,
    loading,
  };
};
